import CollectionContextMenu from './CollectionContextMenu.container'
export default CollectionContextMenu
